/* eslint-disable react/no-array-index-key */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Text } from "@quintoandar-tokko/jopijs";
import style from "./priceProperty.module.scss";
import Trans from "@/components/shared/Trans";
import translations from "../../FichaInfo.trans.json";
import OperationEditionCard from "./operationCard/OperationEditionCard";
import ToolTipOperationCard from "./operationCard/ToolTipOperationCard";
import { updateDisabledOperationOff } from "@/store/slices/components/fichaInfo/FichaInfoSlice";
import Skeleton from "../../skelenton/Skeleton";

export default function PriceProperty() {
  const state = useSelector((ste) => ste.FichaInfoSlice);
  const {
    isEdition,
    showData,
    edited_data,
    origin_data,
    disabledOperationOff,
    loading,
    from_opennavent
  } = state;
  const dipatch = useDispatch();
  const OperationsName = {
    Sale: Trans(translations, "Sale"),
    Rent: Trans(translations, "Rent"),
    Temporary: Trans(translations, "Temporary"),
  };
  
  useEffect(() => {
    dipatch(updateDisabledOperationOff(state));
  }, [isEdition]);

  const {on_web_price} = origin_data;
  if(!on_web_price && !from_opennavent) return null;

  const desiredOrder = ["Sale", "Rent", "Temporary"];

  const checkAvailableOperations = (operations) => {
    let editedOpKey = `show_operation_${operations.toLocaleLowerCase()}`;
    if (operations.toLocaleLowerCase() === "temporary") editedOpKey += "_rent";
    return edited_data[editedOpKey];
  };
  const orderedKeys = (disorderedOp) =>
    desiredOrder.filter((key) => Object.keys(disorderedOp).includes(key));

  const visibleOperations = (operations) =>
    showData === "origin_data" || checkAvailableOperations(operations);

  const oneOperationsTwoMoney = () => {
    const operations = origin_data.operations;
    let almostOne = false;
    Object.keys(operations).forEach((op) => {
      if (operations[op].length > 1) almostOne = true;
    });
    return almostOne;
  };

  if (loading)
    return (
      <Box className={style.pricePropertySkeletonsContainer}>
        <Skeleton borderRadius={50} height={60} />
      </Box>
    );


  return (
    <Box className={style.pricePropertyContainer}>
      {isEdition && orderedKeys(origin_data.operations).length > 1
        ? orderedKeys(origin_data.operations).map((op, index) =>
            checkAvailableOperations(op) && disabledOperationOff ? (
              <ToolTipOperationCard key={`${op}+${index}`}>
                <OperationEditionCard
                  twoRow={oneOperationsTwoMoney()}
                  op={op}
                  index={index}
                />
              </ToolTipOperationCard>
            ) : (
              <OperationEditionCard
                twoRow={oneOperationsTwoMoney()}
                op={op}
                key={op}
                index={index}
              />
            )
          )
        : orderedKeys(origin_data.operations).map(
            (op, index) =>
              visibleOperations(op) && (
                <Box key={`${op}+${index}`} className={style.pricePropertyItem}>
                  <Box as="span" className={style.typeOperationTag}>
                    {OperationsName[op]}
                  </Box>
                  {Array(2)
                    .fill()
                    .map((el, i) => (
                      <Box key={`${el}${i}`} className={style.priceCointainer}>
                        <Text
                          key={origin_data.operations[op][i] + i}
                          className={style.price}
                          variant="bodyBold.fontSize20"
                        >
                          {origin_data.operations[op][i]?.split(' ')[0] ===
                            origin_data.operations?.promotional_price?.[op]?.currency &&
                          Object.keys(origin_data.operations?.promotional_price ?? {}).includes(op) ? (
                            <Box __css={{ display: 'flex', gap: '8px' }}>
                              <span>{origin_data.operations?.promotional_price[op].text}</span>
                              <span className={style.noPromoPrice}>{origin_data.operations[op][i]}</span>
                            </Box>
                          ) : (
                            origin_data.operations[op][i] || null
                          )}
                        </Text>
                      </Box>
                    ))}
                </Box>
              )
          )}
    </Box>
  );
}
